import { HIDE_TOAST, showSuccessToast, showToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { i18nFilter } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";

import type { Integration } from "../../types";
import { managementActions } from "../action-creators";
import { setRecordToEnableExport } from "../actions/common";
import { selectCurrentExportTab, selectRecordToEnableExport } from "../selectors/common";
import type { ExportName } from "../type";

export const trackEnableRecordExportCanceled =
    (integrationName: Integration) => (dispatch: ThunkDispatchCommon, getState: ThunkGetState) => {
        const recordToEnableExport = selectRecordToEnableExport(getState());
        if (!recordToEnableExport) {return;}

        const integrationText = `${integrationName} integration`;

        allTrackers.dispatchTrackEvent(
            integrationText,
            "export activated",
            `activation cancelled/${recordToEnableExport}/${integrationText}`,
        );

        dispatch(setRecordToEnableExport(null));
    };

export const setTabNameThunk =
    (currentTabName: ExportName) => (dispatch: ThunkDispatchCommon, getState: ThunkGetState) => {
        const state = getState();

        const previousTabName = selectCurrentExportTab(state);

        dispatch(managementActions.common.setCurrentExportTab({ currentTabName, previousTabName }));
    };

export const exportToCrmToastThunk = (text: string, link?: string, tag?: string) => {
    return (dispatch: ThunkDispatchCommon) => {
        const timestamp = Date.now();

        const handleHideToast = () => {
            dispatch({
                type: HIDE_TOAST,
                toast: { timestamp },
            });
        };

        const toast = getToastItemComponent({
            text,
            onClick: handleHideToast,
            href: link,
            linkText: link ? i18nFilter()("si.management.sf.settings_export.toast.log") : undefined,
        });

        if (tag) {
            dispatch(showSuccessToast(toast, timestamp, undefined, undefined, tag));
        } else {
            dispatch(showToast(toast, "success", timestamp));
        }
    };
};
